import { Badge } from '@/components/ui/badge'
import { Spinner } from '@/components/ui/spinner'

interface FillStepLabelProps {
  label: string
  /** Missing or invalid items on the tab. */
  toFix?: number
  unsaved?: boolean
  reading?: boolean
}

export function FillStepLabel({ label, toFix = 0, unsaved = false, reading = false }: FillStepLabelProps) {
  return (
    <span className="flex items-center gap-1.5">
      {label}
      {reading && <Spinner className="size-3.5" aria-label="Reading files" />}
      {toFix > 0 && (
        <Badge variant="warning" className="px-1.5">
          {toFix}
          <span className="sr-only"> to fix</span>
        </Badge>
      )}
      {unsaved && (
        <>
          <span aria-hidden className="size-1.5 rounded-full bg-(--amber)" />
          <span className="sr-only">, unsaved</span>
        </>
      )}
    </span>
  )
}
